import { PackedGrid } from "permissions/_views/tables/permissions-table-styles";
import { DocumentContentsAccess } from "permissions/resources/documents/documents-permissions-resources";
import { LegalEntityAccess } from "permissions/resources/legal-entities/legal-entities-permissions-resources";
import type { Resource } from "permissions/resources/permission-resource";
import { ResourceConstructor } from "permissions/resources/types";
import { TableRow } from "permissions/_views/types/permission-types";
import { JSX } from "react";

type SingleGranteeResourceCell = {
  row: TableRow;
  topLevelResources: ResourceConstructor[];
  topLevelTemplates: {
    byConstructor: Map<ResourceConstructor, Resource>;
    legalByAccessType: Map<string, Resource>;
    docContentsBySubject: Map<string, Resource>;
  };
  isSingleGranteeView: boolean;
  isManageTemplatesView?: boolean;
  canEdit: boolean;
  renderLegalEntityCell: (
    row: TableRow,
    topLevelTemplates: {
      byConstructor: Map<ResourceConstructor, Resource>;
      legalByAccessType: Map<string, Resource>;
      docContentsBySubject: Map<string, Resource>;
    },
    isSingleGranteeView: boolean,
    canEdit: boolean
  ) => JSX.Element;
  renderDocumentSubjectMatterCell: (
    row: TableRow,
    topLevelTemplates: {
      byConstructor: Map<ResourceConstructor, Resource>;
      legalByAccessType: Map<string, Resource>;
      docContentsBySubject: Map<string, Resource>;
    },
    isSingleGranteeView: boolean,
    canEdit: boolean
  ) => JSX.Element;
  renderSingleTopLevelPermission: (row: TableRow, resource: ResourceConstructor, canEdit: boolean) => JSX.Element;
};

export default function SingleGranteeResourceCell(props: Readonly<SingleGranteeResourceCell>) {
  const {
    row,
    topLevelResources,
    topLevelTemplates,
    isSingleGranteeView,
    isManageTemplatesView,
    canEdit,
    renderLegalEntityCell,
    renderDocumentSubjectMatterCell,
    renderSingleTopLevelPermission,
  } = props;

  return (
    <PackedGrid dense={isManageTemplatesView}>
      {topLevelResources.map((resource: ResourceConstructor) => {
        if (resource === LegalEntityAccess) {
          return renderLegalEntityCell(row, topLevelTemplates, isSingleGranteeView, canEdit);
        } else if (resource === DocumentContentsAccess) {
          return renderDocumentSubjectMatterCell(row, topLevelTemplates, isSingleGranteeView, canEdit);
        } else {
          return renderSingleTopLevelPermission(row, resource, canEdit);
        }
      })}
    </PackedGrid>
  );
}
